import { EncryptStorage } from 'encrypt-storage';
import { useEffect, useState } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { setHours, setMinutes, addMinutes, isSameDay, getHours, differenceInMinutes, addDays } from 'date-fns';
import { loadStripe } from '@stripe/stripe-js';

export const encryptStorage = new EncryptStorage('P9X2X5Z8*.');
const googleMapsLibraries = ['geometry'];
//let stripePublishableKey = '';
export let stripePromise = null;

// ******************** MÉTODOS ÚTEIS ******************** //

export const removeEmojis = (text) => {
  // Remover emojis usando uma expressão regular
  return text?.replace(
    // eslint-disable-next-line no-misleading-character-class
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1F9A0}-\u{1F9FF}\u{1F3FB}-\u{1F3FF}]/gu,
    '',
  );
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function doRedirectUrl() {
  var promise = new Promise(function (resolve) {
    let urlCompleta = window.location.href;

    if (urlCompleta.includes('geneseweb')) {
      urlCompleta = urlCompleta.replace('geneseweb', 'garcomweb');
      window.location.replace(urlCompleta);
    }
    resolve(true);
  });
  return promise; // This is what we'll use later. Promise that something will happen!
}

// export const redirectUrl = new Promise((resolve) => {
//   let urlCompleta = window.location.href;

//   if (urlCompleta.includes('loja/4')) {
//     urlCompleta = urlCompleta.replace('loja/4', 'loja/2');
//     window.location.replace(urlCompleta);
//   }
//   resolve(true);
// });

export function setStripePromise(key) {
  if (stripePromise === null) {
    stripePromise = loadStripe(key);
  }
}

export function getStripePromise() {
  return stripePromise;
}

export function PositionPerfilOptionsPopUp() {
  var os = document.getElementById('btn-menu').getBoundingClientRect();
  const { width } = getWindowDimensions();

  setTimeout(() => {
    const element = document.querySelector('.modal');
    if (width >= 500) {
      // codigo quando o menu esta na direita
      //let left = os.left - 283 + 'px'; // 283 + 'px';
      // element.style.marginLeft = left;
      // element.style.marginTop = 0;

      // codigo quando o menu esta na esquerda
      let left = os.left - 0 + 'px'; // 283 + 'px';
      element.style.marginLeft = left;
      element.style.marginTop = 0;
    }
    element.style.display = 'block';
  }, 100);
}

export const ScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export function GetDadosProduto(dadosApp, codigo) {
  const produto = dadosApp.Cardapio.Produtos.filter((p) => p.codigo == codigo);
  if (produto.length > 0) return produto[0];
  else return {};
}

export function GetMontagem(dadosApp, codigo, id = 0, produto) {
  const item = dadosApp.Cardapio.Produtos.filter((p) => p.codigo === codigo);
  let montagem = [];
  let itensEdicao = [];

  if (item.length == 0) return montagem;

  if (id > 0) {
    const allItens = GetAllItensSacola(dadosApp.IdLoja);

    // adicionei por conta dos produtos que tem multpreço
    allItens
      .filter((p) => p.id == id)
      .map((p) => {
        p.quantidade = p.quantidade / produto.quantidade; // divido a quantidade para que possa ser editado corretamente
        itensEdicao.push(p);
      });
    // adicionei por conta dos produtos que tem multpreço

    allItens
      .filter((p) => p.montagem_id == id)
      .map((p) => {
        p.quantidade = p.quantidade / produto.quantidade; // divido a quantidade para que possa ser editado corretamente
        itensEdicao.push(p);
      });

    allItens
      .filter((p) => p.obrigatorio_id == id)
      .map((p) => {
        p.quantidade = p.quantidade / produto.quantidade; // divido a quantidade para que possa ser editado corretamente
        itensEdicao.push(p);
      });

    allItens
      .filter((p) => p.adicionais_id == id)
      .map((p) => {
        p.quantidade = p.quantidade / produto.quantidade; // divido a quantidade para que possa ser editado corretamente
        itensEdicao.push(p);
      });
  }

  let primeroPedaco = true; // utilizado para colocar o produto principal na primeira posição da lista de montagem
  //const newItem = { ...item[0] }; // clona o produto principal
  const newItem = JSON.parse(JSON.stringify(item[0]));

  // VERIFICA SE TEM ITENS DE MONTAGEM PRA PIZZA
  if (newItem.montagem_titulo !== '' && newItem.tipo_produto == 'PIZZA' && newItem.pizza_qtd_max > 0) {
    const logicaNova = dadosApp.Cardapio.Pizzas?.length > 0;
    if (logicaNova) {
      //dadosApp.Cardapio.Pizzas // antes nao era clonado, o que fazia com que ficasse sujeira a cada lancamento e eu precisava ficar limpando
      const clonePizzas = JSON.parse(JSON.stringify(dadosApp.Cardapio.Pizzas)); // clona as pizzas, solucao para o bug de ja vir preenchido quantidades nas montagens
      clonePizzas
        ?.filter(
          (p) => p.grupo_pizza === newItem.montagem_titulo && p.Produto.codigo_produto !== parseFloat(newItem.codigo),
        )
        .sort(function (a, b) {
          if (a.titulo === b.titulo) {
            // Titulo is only important when Titulo are the same
            return a.Produto.ordem_app - b.Produto.ordem_app;
          }
          return a.ordem > b.ordem ? 1 : -1;
        })
        .map((piz) => {
          newItem.quantidade = 1; // correção bug pizza
          newItem.quantidade_texto = '1/1';
          if (primeroPedaco) {
            montagem.push({
              Produto: newItem,
              QtdeObrigatoria: 1,
              QtdeObrigatoriaOriginal: 1,
              TipoMontagem: 'PIZZA',
              Titulo: `Escolha até ${newItem.pizza_qtd_max} sabores`,
            });
          }

          primeroPedaco = false;

          // SE ESTIVER EDITANDO, SELECIONA OS ITENS CONFORME FORAM GRAVADOS
          if (itensEdicao.length > 0) {
            itensEdicao
              .filter(({ montagem_id, codigo_produto }) => montagem_id === id && codigo_produto === piz.Produto.codigo)
              .map((p) => {
                piz.Produto.id = p.id;
                piz.Produto.quantidade = p.quantidade;
              });
          }
          montagem.push({
            Produto: piz.Produto,
            QtdeObrigatoria: 1,
            QtdeObrigatoriaOriginal: 1,
            TipoMontagem: 'PIZZA',
            Titulo: `Escolha até ${newItem.pizza_qtd_max} sabores`,
          });
        });
    } else {
      // pizza lógica antiga
      //dadosApp.Cardapio.Produtos // antes nao era clonado, o que fazia com que ficasse sujeira a cada lancamento e eu precisava ficar limpando
      const clonePizzas = JSON.parse(JSON.stringify(dadosApp.Cardapio.Produtos)); // clona as pizzas, solucao para o bug de ja vir preenchido quantidades nas montagens
      clonePizzas
        .filter((p) => p.montagem_titulo === newItem.montagem_titulo && p.codigo !== newItem.codigo)
        //.sort((order) => order.Ordem)
        .sort(function (a, b) {
          if (a.Titulo === b.Titulo) {
            // Titulo is only important when cities are the same
            return a.Ordem - b.Ordem;
          }
          return a.Titulo > b.Titulo ? 1 : -1;
        })
        .map((piz) => {
          newItem.quantidade = 1; // correção bug pizza
          newItem.quantidade_texto = '1/1';

          if (primeroPedaco) {
            montagem.push({
              Produto: newItem,
              QtdeObrigatoria: 1,
              QtdeObrigatoriaOriginal: 1,
              TipoMontagem: 'PIZZA',
              Titulo: `Escolha até ${newItem.pizza_qtd_max} sabores`,
            });
          }

          primeroPedaco = false;

          // SE ESTIVER EDITANDO, SELECIONA OS ITENS CONFORME FORAM GRAVADOS
          if (itensEdicao.length > 0) {
            itensEdicao
              .filter(({ montagem_id, codigo_produto }) => montagem_id === id && codigo_produto === piz.codigo)
              .map((p) => {
                piz.id = p.id;
                piz.quantidade = p.quantidade;
              });
          } else {
            //piz.quantidade = 0; // bug da pizza este era o principal problema
          }

          montagem.push({
            Produto: piz,
            QtdeObrigatoria: 1,
            QtdeObrigatoriaOriginal: 1,
            TipoMontagem: 'PIZZA',
            Titulo: `Escolha até ${newItem.pizza_qtd_max} sabores`,
          });
          // montagem.push({
          //   Produto: primeroPedaco ? newItem : piz,
          //   QtdeObrigatoria: 1,
          //   QtdeObrigatoriaOriginal: 1,
          //   TipoMontagem: 'PIZZA',
          //   Titulo: `Escolha até ${item[0].pizza_qtd_max} sabores`,
          // });

          // primeroPedaco = false;
        });
    }
  }

  // VERIFICA SE TEM OBRIGATORIOS
  if (item[0].grupo_obrigatorio !== '') {
    //dadosApp.Cardapio.Obrigatorios // antes nao era clonado, o que fazia com que ficasse sujeira a cada lancamento e eu precisava ficar limpando
    const cloneObrigatorios = JSON.parse(JSON.stringify(dadosApp.Cardapio.Obrigatorios)); // clona os obrigatorios, solucao para o bug de ja vir preenchido quantidades nas montagens
    cloneObrigatorios
      .filter((p) => p.GrupoObrigatorio === item[0].grupo_obrigatorio)
      .sort(function (a, b) {
        if (a.Titulo === b.Titulo) {
          // Titulo is only important when Titulo are the same
          return a.Produto.ordem_app - b.Produto.ordem_app;
        }
        return a.Ordem > b.Ordem ? 1 : -1;
      })
      .map((obrig) => {
        // SE ESTIVER EDITANDO, SELECIONA OS ITENS CONFORME FORAM GRAVADOS
        if (itensEdicao.length > 0) {
          itensEdicao
            .filter(
              ({ obrigatorio_id, codigo_produto }) => obrigatorio_id === id && codigo_produto === obrig.Produto.codigo,
            )
            .map((p) => {
              obrig.Produto.id = p.id;
              obrig.Produto.quantidade = p.quantidade;
            });
        }

        montagem.push({
          Produto: obrig.Produto,
          QtdeObrigatoria: 1,
          QtdeObrigatoriaOriginal: 1,
          TipoMontagem: 'OBRIGATORIO',
          Titulo: obrig.Titulo,
        });
      });
  }

  // VERIFICA SE TEM ITENS COMBO
  if (item[0].montagem_titulo !== '' && item[0].tipo_produto == 'COMBO') {
    //dadosApp.Cardapio.Combos // antes nao era clonado, o que fazia com que ficasse sujeira a cada lancamento e eu precisava ficar limpando
    const cloneCombos = JSON.parse(JSON.stringify(dadosApp.Cardapio.Combos)); // clona os combos, solucao para o bug de ja vir preenchido quantidades nas montagens
    cloneCombos
      .filter((p) => p.titulo === item[0].montagem_titulo)
      .sort(function (a, b) {
        if (a.nome_categoria === b.nome_categoria) {
          // Titulo is only important when Titulo are the same
          return a.Produto.ordem_app - b.Produto.ordem_app;
        }
        return a.ordenacao > b.ordenacao ? 1 : -1;
      })
      // .sort(function (a, b) {
      //   if (a.Titulo === b.Titulo) {
      //     // Titulo is only important when cities are the same
      //     return a.Ordem - b.Ordem;
      //   }
      //   return a.Titulo > b.Titulo ? 1 : -1;
      // })
      .map((cmb) => {
        // SE ESTIVER EDITANDO, SELECIONA OS ITENS CONFORME FORAM GRAVADOS
        if (itensEdicao.length > 0) {
          itensEdicao
            .filter(({ montagem_id, codigo_produto }) => montagem_id === id && codigo_produto === cmb.Produto.codigo)
            .map((p) => {
              cmb.Produto.id = p.id;
              cmb.Produto.quantidade = p.quantidade;
            });
        }

        montagem.push({
          Produto: cmb.Produto,
          QtdeObrigatoria: cmb.qtd,
          QtdeObrigatoriaOriginal: cmb.qtd,
          TipoMontagem: 'COMBO',
          Titulo: cmb.nome_categoria,
        });
      });
  }

  // VERIFICA SE TEM ADICIONAIS
  if (item[0].grupo_adicional !== '') {
    //dadosApp.Cardapio.Adicionais // antes nao era clonado, o que fazia com que ficasse sujeira a cada lancamento e eu precisava ficar limpando
    const cloneAdicionais = JSON.parse(JSON.stringify(dadosApp.Cardapio.Adicionais)); // clona os adicionais, solucao para o bug de ja vir preenchido quantidades nas montagens
    cloneAdicionais
      .filter((p) => p.GrupoAdicionais === item[0].grupo_adicional)
      .sort(function (a, b) {
        if (a.Titulo === b.Titulo) {
          // Titulo is only important when Titulo are the same
          return a.Produto.ordem_app - b.Produto.ordem_app;
        }
        return a.Ordem > b.Ordem ? 1 : -1;
        // if (a.titulo === b.titulo) {
        //   // Titulo is only important when cities are the same
        //   return a.ordem - b.ordem;
        // }
        // return a.titulo > b.titulo ? 1 : -1;
      })
      // .sort(function (a, b) {
      //   if (a.Titulo === b.Titulo) {
      //     // Titulo is only important when cities are the same
      //     return a.Ordem - b.Ordem;
      //   }
      //   return a.Titulo > b.Titulo ? 1 : -1;
      // })
      .map((adic) => {
        // SE ESTIVER EDITANDO, SELECIONA OS ITENS CONFORME FORAM GRAVADOS

        if (itensEdicao.length > 0) {
          itensEdicao
            .filter(
              ({ adicionais_id, codigo_produto }) => adicionais_id === id && codigo_produto === adic.Produto.codigo,
            )
            .map((p) => {
              adic.Produto.id = p.id;
              adic.Produto.quantidade = p.quantidade;
            });
        }

        montagem.push({
          Produto: adic.Produto,
          QtdeObrigatoria: 0,
          QtdeObrigatoriaOriginal: 0,
          TipoMontagem: 'ADICIONAL',
          //Titulo: 'Acompanhamento Extra',
          Titulo: adic.Titulo === '' ? 'Acompanhamento Extra' : adic.Titulo,
          QtdMaxima: adic.QtdMaxima,
        });
      });
  }

  // cria os grupos da lista de montagem

  return { montagem: montagem, itensEdicao: itensEdicao, group: [...new Set(montagem.map((item) => item.Titulo))] };
}

// MÉTODO ORIGINAL
// export function GetStatusLoja(dados, statusLoja, setStatusLoja) {
//   if (dados === undefined) return false;

//   const isAutoAtendimento = dados.Empresa?.Empresa?.tipo_app !== 'DELIVERY';
//   const newStatus = isAutoAtendimento
//     ? dados.Empresa?.Config?.auto_atendimento_mesa | true
//     : verificaLojaAberta(dados.Empresa.Config, dados.DiaSemana);

//   // só atualiza o status da loja se ele mudar
//   if (newStatus != statusLoja.StatusLoja) setStatusLoja({ StatusLoja: newStatus });
//   return newStatus;
// }
// MÉTODO ORIGINAL

export async function GetStatusLoja(dadosApp, statusLoja, setStatusLoja) {
  if (dadosApp === undefined) return false;

  const isAutoAtendimento = dadosApp.Empresa?.Empresa?.tipo_app !== 'DELIVERY';
  const newStatus = isAutoAtendimento
    ? dadosApp.Empresa?.Config?.auto_atendimento_mesa | true
    : verificaLojaAberta(dadosApp.Empresa.Config, dadosApp.DiaSemana);

  let result = await GetTextStatusLoja(dadosApp?.Empresa?.Config);
  result.text = newStatus ? 'Loja Aberta' : result.text;

  if (result.text === 'Loja Fechada') {
    result = await GetNextDayOpened(new Date(Date.now()), dadosApp?.Empresa?.Config);
  }

  if (statusLoja.StatusText !== result.text || statusLoja.StatusLoja !== newStatus) {
    setStatusLoja({
      StatusLoja: newStatus,
      StatusText: newStatus ? 'Loja Aberta' : result.text,
      NextValidDay: result.date,
    });
  }

  return newStatus;
}

export async function GetNextDayOpened(date, config) {
  let result = await GetTextStatusLoja(config, addDays(date, 1), true);
  if (result.text !== 'Loja Fechada') return result;

  result = await GetTextStatusLoja(config, addDays(date, 2), true);
  if (result.text !== 'Loja Fechada') return result;

  result = await GetTextStatusLoja(config, addDays(date, 3), true);
  if (result.text !== 'Loja Fechada') return result;

  result = await GetTextStatusLoja(config, addDays(date, 4), true);
  if (result.text !== 'Loja Fechada') return result;

  result = await GetTextStatusLoja(config, addDays(date, 5), true);
  if (result.text !== 'Loja Fechada') return result;

  result = await GetTextStatusLoja(config, addDays(date, 6), true);
  if (result.text !== 'Loja Fechada') return result;

  return await GetTextStatusLoja(config, addDays(date, 7), true);
}

async function HandleStatusLoja(config, today, abertura, intervalo, fechamento, nextDay) {
  const _hora = abertura.substring(0, 2);
  const _minutos = abertura.substring(3, 5);
  const _date = setHours(setMinutes(today, _minutos), _hora);

  if (nextDay) {
    const _horaAbertura = abertura.substring(0, 2);
    const _minutosAbertura = abertura.substring(3, 5);
    const _dateAbertura = setHours(setMinutes(today, _minutosAbertura), _horaAbertura);
    return {
      text:
        'Abre ' +
        Capitalize(
          _dateAbertura.toLocaleTimeString('pt-BR', {
            weekday: 'short',
            // year: 'numeric',
            // month: 'long',
            // day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            // second: '2-digit',
            // hour12: false,
          }),
        ).replace(',', ''),
      date: _dateAbertura,
    };
  }

  if (today > _date) {
    if (intervalo === 1) {
      const _horaReabertura = fechamento.substring(0, 2);
      const _minutosReabertura = fechamento.substring(3, 5);
      const _dateReabertura = setHours(setMinutes(today, _minutosReabertura), _horaReabertura);
      const diffInHours = differenceInMinutes(_dateReabertura, today);
      if (diffInHours > 60) {
        return {
          text:
            'Abre às ' +
            _dateReabertura.toLocaleTimeString('pt-BR', {
              hour: '2-digit',
              minute: '2-digit',
            }),
          date: _dateReabertura,
        };
      } else {
        return { text: 'Abre em ' + diffInHours + 'min', date: _dateReabertura };
      }
    } else {
      return { text: 'Loja Fechada', date: _date };
    }
  } else {
    const diffInHours = differenceInMinutes(_date, today);
    if (diffInHours > 60) {
      return {
        text:
          'Abre às ' +
          _date.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
          }),
        date: _date,
      };
    } else {
      return {
        text: 'Abre em ' + diffInHours + 'min',
        date: _date,
      };
    }
  }
}

export async function GetTextStatusLoja(config, _date = new Date(Date.now()), nextDay = false) {
  let _status = { text: 'Loja Fechada', date: new Date(), hour: new Date() };

  switch (_date.getDay()) {
    case 0: // DOMINGO
      if (config.domingo === 1) {
        _status = await HandleStatusLoja(
          config,
          _date,
          config.dom_abertura,
          config.dom_intervalo,
          config.dom_intervalo_fechamento,
          nextDay,
        );
      }
      break;
    case 1: // SEGUNDA
      if (config.segunda === 1) {
        _status = await HandleStatusLoja(
          config,
          _date,
          config.seg_abertura,
          config.seg_intervalo,
          config.seg_intervalo_fechamento,
          nextDay,
        );
      }
      break;
    case 2: // TERÇA
      if (config.terca === 1) {
        _status = await HandleStatusLoja(
          config,
          _date,
          config.ter_abertura,
          config.ter_intervalo,
          config.ter_intervalo_fechamento,
          nextDay,
        );
      }
      break;
    case 3: // QUARTA
      if (config.quarta === 1) {
        _status = await HandleStatusLoja(
          config,
          _date,
          config.qua_abertura,
          config.qua_intervalo,
          config.qua_intervalo_fechamento,
          nextDay,
        );
      }
      break;
    case 4: // QUINTA
      if (config.quinta === 1) {
        _status = await HandleStatusLoja(
          config,
          _date,
          config.qui_abertura,
          config.qui_intervalo,
          config.qui_intervalo_fechamento,
          nextDay,
        );
      }
      break;
    case 5: // SEXTA
      if (config.sexta === 1) {
        _status = await HandleStatusLoja(
          config,
          _date,
          config.sex_abertura,
          config.sex_intervalo,
          config.sex_intervalo_fechamento,
          nextDay,
        );
      }
      break;
    case 6: // SÁBADO
      if (config.sabado === 1) {
        _status = await HandleStatusLoja(
          config,
          _date,
          config.sab_abertura,
          config.sab_intervalo,
          config.sab_intervalo_fechamento,
          nextDay,
        );
      }
      break;
    default:
      break;
  }
  return _status;
}

export function UpdateItensCount(idLoja, setSacola) {
  const obj = GetSacolaItensCount(idLoja);
  setSacola({ TotalItens: obj.itensCount, ValorTotal: obj.vTotal });
}

export function GetDiaSemanaLocal() {
  var options = {
    weekday: 'short',
    // year: 'numeric',
    // month: 'long',
    // day: 'numeric',
    // hour: '2-digit',
    // minute: '2-digit',
    // second: '2-digit',
    // hour12: false,
  };
  return new Date().toLocaleDateString('pt-BR', options).replace('.', '');
}

export function FormatDateTime(date) {
  var options = {
    //weekday: 'short',
    //year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    // second: '2-digit',
    // hour12: false,
  };
  return new Date(date).toLocaleDateString('pt-BR', options).replace('.', '');
}

export function GetDiaSemanaByDate(date) {
  if (date) {
    var options = {
      weekday: 'short',
      // year: 'numeric',
      // month: 'long',
      // day: 'numeric',
      // hour: '2-digit',
      // minute: '2-digit',
      // second: '2-digit',
      // hour12: false,
    };
    return date.toLocaleDateString('pt-BR', options).replace('.', '');
  } else {
    return new Date().toLocaleDateString('pt-BR', options).replace('.', '');
  }
}

export function generateAvailableTimes(configuracoes, data) {
  const horariosDisponiveis = [];

  const dataAgendamento = new Date(
    data.getFullYear(),
    data.getMonth(),
    data.getDate(),
    new Date().getHours(),
    new Date().getMinutes(),
    new Date().getSeconds(),
  );

  const diaSemana = dataAgendamento.getDay();
  const diaAgendamento = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'][diaSemana];

  const abertura = new Date(dataAgendamento);
  abertura.setHours(Number(configuracoes[`${diaAgendamento}_abertura`].substring(0, 2)));
  abertura.setMinutes(Number(configuracoes[`${diaAgendamento}_abertura`].substring(3, 5)));

  const _dataAberturaInicial = new Date(dataAgendamento);
  _dataAberturaInicial.setHours(Number(configuracoes[`${diaAgendamento}_abertura`].substring(0, 2)));
  _dataAberturaInicial.setMinutes(Number(configuracoes[`${diaAgendamento}_abertura`].substring(3, 5)));

  const fechamento = new Date(dataAgendamento);
  fechamento.setHours(Number(configuracoes[`${diaAgendamento}_fechamento`].substring(0, 2)));
  fechamento.setMinutes(Number(configuracoes[`${diaAgendamento}_fechamento`].substring(3, 5)));

  if (Number(configuracoes[`${diaAgendamento}_fechamento`].substring(0, 2)) === 0) fechamento.setHours(23, 59, 59);

  const consideraIntervalo = configuracoes[`${diaAgendamento}_intervalo`] === 1;

  const intervaloAbertura = new Date(dataAgendamento);
  intervaloAbertura.setHours(Number(configuracoes[`${diaAgendamento}_intervalo_abertura`].substring(0, 2)));
  intervaloAbertura.setMinutes(Number(configuracoes[`${diaAgendamento}_intervalo_abertura`].substring(3, 5)));

  const intervaloFechamento = new Date(dataAgendamento);
  intervaloFechamento.setHours(Number(configuracoes[`${diaAgendamento}_intervalo_fechamento`].substring(0, 2)));
  intervaloFechamento.setMinutes(Number(configuracoes[`${diaAgendamento}_intervalo_fechamento`].substring(3, 5)));

  const intervaloFechamentoEmMinutos = intervaloFechamento.getHours() * 60 + intervaloFechamento.getMinutes();

  const consideraPrevisaoEntrega = configuracoes.considera_previsao_entrega === 1;
  const previsaoEntregaMinutos = consideraPrevisaoEntrega ? configuracoes.previsao_entrega : 0;

  const hoje = new Date();
  const ehHoje = dataAgendamento.toDateString() === hoje.toDateString();

  while (abertura <= fechamento) {
    const horarioEmMinutos = abertura.getHours() * 60 + abertura.getMinutes();
    const horarioAtual = new Date().getHours() * 60 + new Date().getMinutes();

    if (ehHoje) {
      const isHorarioValido =
        (!consideraIntervalo || abertura < intervaloAbertura || abertura >= intervaloFechamento) &&
        (!consideraPrevisaoEntrega ||
          (dataAgendamento.toDateString() === new Date().toDateString() && horarioAtual <= horarioEmMinutos) ||
          (dataAgendamento.toDateString() !== new Date().toDateString() &&
            dataAgendamento <= abertura.getTime() + previsaoEntregaMinutos * 60000));

      if (isHorarioValido) {
        if (consideraPrevisaoEntrega) {
          // para aplicar a regra: consideraPrevisaoEntrega quando tiver intervalo
          if (abertura >= intervaloAbertura && abertura <= intervaloFechamento) {
            if (consideraIntervalo) {
              const diffIntervalo = horarioEmMinutos - intervaloFechamentoEmMinutos;
              if (diffIntervalo >= previsaoEntregaMinutos) horariosDisponiveis.push(new Date(abertura));
            } else {
              //const diffInMinutes = differenceInMinutes(abertura, new Date()); // comentei

              const diffInMinutes = differenceInMinutes(abertura, dataAgendamento); // comentei
              if (diffInMinutes >= previsaoEntregaMinutos) horariosDisponiveis.push(new Date(abertura));
            }
          } else {
            const diffInMinutes = differenceInMinutes(abertura, dataAgendamento); // new Date() // estava errado como new Date
            if (diffInMinutes >= previsaoEntregaMinutos) horariosDisponiveis.push(new Date(abertura));
          }
        } else {
          // importante para que não aceite agendamentos com horario anterior ao atual
          const diffInMinutes = differenceInMinutes(abertura, dataAgendamento);

          if (diffInMinutes >= 0) {
            horariosDisponiveis.push(new Date(abertura));
          }
        }
      }
    } else {
      if (consideraPrevisaoEntrega) {
        const diffInMinutes = differenceInMinutes(abertura, _dataAberturaInicial);
        if (diffInMinutes >= previsaoEntregaMinutos) horariosDisponiveis.push(new Date(abertura));
      } else horariosDisponiveis.push(new Date(abertura));
    }

    abertura.setMinutes(abertura.getMinutes() + 15);
  }

  return horariosDisponiveis;
}

export function GetTimesEntregaProgramada(
  _date,
  abertura,
  fechamento,
  intervalo,
  InicioIntervalo,
  FimIntervalo,
  _include = [],
  CONFIG,
) {
  const isToday = isSameDay(new Date(), _date);
  const horaAtual = getHours(new Date());

  const horaAbertura = parseInt(abertura.substring(0, 2));
  //const minutoAbertura = parseInt(abertura.substring(3, 5));

  const horaInicioIntervalo = parseInt(InicioIntervalo.substring(0, 2));
  //const minutoInicioIntervalo = parseInt(InicioIntervalo.substring(3, 5));
  const horaFimIntervalo = parseInt(FimIntervalo.substring(0, 2));
  const minutoFimIntervalo = parseInt(FimIntervalo.substring(3, 5));

  const horaFechamento = parseInt(fechamento.substring(0, 2));
  //const minutoFechamento = parseInt(fechamento.substring(3, 5));

  // looping de 24h
  for (let hora = 0; hora < 24; hora++) {
    if (
      (!isToday && hora >= horaAbertura && hora <= horaFechamento) ||
      (isToday && hora >= horaAtual && hora >= horaAbertura && hora <= horaFechamento)
    ) {
      if (intervalo === 0) {
        if (hora !== horaFechamento) {
          if (CONFIG.considera_previsao_entrega) {
            const _hora1 = setHours(setMinutes(_date, 0), hora);
            const _hora2 = setHours(setMinutes(_date, 15), hora);
            const _hora3 = setHours(setMinutes(_date, 30), hora);
            const _hora4 = setHours(setMinutes(_date, 45), hora);
            const dataPrevisao = addMinutes(new Date(), CONFIG.previsao_entrega - 1);

            let diffInMinutes = differenceInMinutes(_hora1, dataPrevisao);
            if (diffInMinutes >= 0) {
              _include.push(setHours(setMinutes(_date, 0), hora));
            }

            diffInMinutes = differenceInMinutes(_hora2, dataPrevisao);
            if (diffInMinutes >= 0) {
              _include.push(setHours(setMinutes(_date, 15), hora));
            }

            diffInMinutes = differenceInMinutes(_hora3, dataPrevisao);
            if (diffInMinutes >= 0) {
              _include.push(setHours(setMinutes(_date, 30), hora));
            }

            diffInMinutes = differenceInMinutes(_hora4, dataPrevisao);
            if (diffInMinutes >= 0) {
              _include.push(setHours(setMinutes(_date, 45), hora));
            }
          } else {
            _include.push(setHours(setMinutes(_date, 0), hora));
            _include.push(setHours(setMinutes(_date, 15), hora));
            _include.push(setHours(setMinutes(_date, 30), hora));
            _include.push(setHours(setMinutes(_date, 45), hora));
          }
        }
      } else {
        if (hora !== horaFechamento) {
          if (CONFIG.considera_previsao_entrega && hora === horaFimIntervalo) {
            if (minutoFimIntervalo <= 15 && CONFIG.previsao_entrega <= 15) {
              _include.push(setHours(setMinutes(_date, 15), hora));
            }
            if (minutoFimIntervalo <= 30 && CONFIG.previsao_entrega <= 30)
              _include.push(setHours(setMinutes(_date, 30), hora));
            if (minutoFimIntervalo <= 45 && CONFIG.previsao_entrega <= 45)
              _include.push(setHours(setMinutes(_date, 45), hora));
          } else {
            if (hora < horaInicioIntervalo || hora > horaFimIntervalo) {
              _include.push(setHours(setMinutes(_date, 0), hora));
              _include.push(setHours(setMinutes(_date, 15), hora));
              //if (minutoFimIntervalo <= 30)
              _include.push(setHours(setMinutes(_date, 30), hora));
              _include.push(setHours(setMinutes(_date, 45), hora));
            }
          }
        }
      }
    }
  }

  return _include?.length > 0 ? _include[0] : [];
}

function ValidaHorarioRestricao(dataInicial, dataFinal) {
  if (dataInicial == '' && dataFinal == '') return true;
  if (dataInicial == '0:00' && dataFinal == '0:00') return true;
  if (dataInicial == '00:00' && dataFinal == '00:00') return true;

  let horaInicial = dataInicial.split(':')[0];
  let minutoInicial = dataInicial.split(':')[1];

  let horaFinal = dataFinal.split(':')[0];
  let minutoFinal = dataFinal.split(':')[1];

  if (horaInicial != '') if (horaInicial.length == 1) horaInicial = '0' + horaInicial;
  if (minutoInicial != '') if (minutoInicial.length == 1) minutoInicial = '0' + minutoInicial;

  if (horaFinal != '') if (horaFinal.Length == 1) horaFinal = '0' + horaFinal;
  if (minutoFinal != '') if (minutoFinal.Length == 1) minutoFinal = '0' + minutoFinal;

  const dateAtual = new Date(Date.now());
  let dateInicial = new Date(
    dateAtual.getFullYear(),
    dateAtual.getMonth(),
    dateAtual.getDate(),
    horaInicial,
    minutoInicial,
    dateAtual.getSeconds(),
  );

  let dateFinal = new Date(
    dateAtual.getFullYear(),
    dateAtual.getMonth(),
    dateAtual.getDate(),
    horaFinal,
    minutoFinal,
    dateAtual.getSeconds(),
  );

  return dateInicial <= dateAtual && dateFinal >= dateAtual;
}

export function verificaDiasRestricao(diaSemana, categoria) {
  let diasRestricao = {
    diaSemana: diaSemana,
    horario: '',
    dias: '',
    eHoje: false,
    podeVender: false,
  };
  switch (diaSemana) {
    case 'dom':
      if (categoria.dom == 1) {
        diasRestricao.eHoje = true;
        diasRestricao.podeVender = ValidaHorarioRestricao(categoria.hora_inicio_dom, categoria.hora_final_dom);
        diasRestricao.horario = categoria.hora_inicio_dom + ' às ' + categoria.hora_final_dom;
      } else diasRestricao.podeVender = false;
      break;

    case 'seg':
      if (categoria.seg == 1) {
        diasRestricao.eHoje = true;
        diasRestricao.podeVender = ValidaHorarioRestricao(categoria.hora_inicio_seg, categoria.hora_final_seg);
        diasRestricao.horario = categoria.hora_inicio_seg + ' às ' + categoria.hora_final_seg;
      } else diasRestricao.podeVender = false;
      break;

    case 'ter':
      if (categoria.ter == 1) {
        diasRestricao.eHoje = true;
        diasRestricao.podeVender = ValidaHorarioRestricao(categoria.hora_inicio_ter, categoria.hora_final_ter);
        diasRestricao.horario = categoria.hora_inicio_ter + ' às ' + categoria.hora_final_ter;
      } else diasRestricao.podeVender = false;
      break;

    case 'qua':
      if (categoria.qua == 1) {
        diasRestricao.eHoje = true;
        diasRestricao.podeVender = ValidaHorarioRestricao(categoria.hora_inicio_qua, categoria.hora_final_qua);
        diasRestricao.horario = categoria.hora_inicio_qua + ' às ' + categoria.hora_final_qua;
      } else diasRestricao.podeVender = false;
      break;

    case 'qui':
      if (categoria.qui == 1) {
        diasRestricao.eHoje = true;
        diasRestricao.podeVender = ValidaHorarioRestricao(categoria.hora_inicio_qui, categoria.hora_final_qui);
        diasRestricao.horario = categoria.hora_inicio_qui + ' às ' + categoria.hora_final_qui;
      } else diasRestricao.podeVender = false;
      break;

    case 'sex':
      if (categoria.sex == 1) {
        diasRestricao.eHoje = true;
        diasRestricao.podeVender = ValidaHorarioRestricao(categoria.hora_inicio_sex, categoria.hora_final_sex);
        diasRestricao.horario = categoria.hora_inicio_sex + ' às ' + categoria.hora_final_sex;
      } else diasRestricao.podeVender = false;
      break;

    case 'sab':
    case 'sáb':
      if (categoria.sab == 1) {
        diasRestricao.eHoje = true;
        diasRestricao.podeVender = ValidaHorarioRestricao(categoria.hora_inicio_sab, categoria.hora_final_sab);
        diasRestricao.horario = categoria.hora_inicio_sab + ' às ' + categoria.hora_final_sab;
      } else diasRestricao.podeVender = false;
      break;

    default:
      break;
  }

  if (diasRestricao.podeVender) {
    diasRestricao.dias = '';
    diasRestricao.horario = '';
  } else {
    if (categoria.seg == 1) diasRestricao.dias = 'Seg';
    if (categoria.ter == 1) {
      if (diasRestricao.dias != '') diasRestricao.dias += ', ';
      diasRestricao.dias += 'Ter';
    }

    if (categoria.qua == 1) {
      if (diasRestricao.dias != '') diasRestricao.dias += ', ';
      diasRestricao.dias += 'Qua';
    }

    if (categoria.qui == 1) {
      if (diasRestricao.dias != '') diasRestricao.dias += ', ';
      diasRestricao.dias += 'Qui';
    }

    if (categoria.sex == 1) {
      if (diasRestricao.dias != '') diasRestricao.dias += ', ';
      diasRestricao.dias += 'Sex';
    }

    if (categoria.sab == 1) {
      if (diasRestricao.dias != '') diasRestricao.dias += ', ';
      diasRestricao.dias += 'Sáb';
    }

    if (categoria.dom == 1) {
      if (diasRestricao.dias != '') diasRestricao.dias += ', ';
      diasRestricao.dias += 'Dom';
    }
  }

  return diasRestricao;
}

export function verificaLojaAberta(config, diaSemana) {
  let lojaAberta = false;

  switch (diaSemana) {
    case 'dom':
      if (config.domingo == 1 && config.dom_intervalo == 1) {
        lojaAberta = ValidaHorarioRestricao(config.dom_abertura, config.dom_intervalo_abertura);
        if (!lojaAberta) lojaAberta = ValidaHorarioRestricao(config.dom_intervalo_fechamento, config.dom_fechamento);
      } else if (config.domingo == 1 && config.dom_intervalo == 0) {
        lojaAberta = ValidaHorarioRestricao(config.dom_abertura, config.dom_fechamento);
      } else lojaAberta = false;
      break;

    case 'seg':
      if (config.segunda == 1 && config.seg_intervalo == 1) {
        //.ToString(@"hh\:mm")
        lojaAberta = ValidaHorarioRestricao(config.seg_abertura, config.seg_intervalo_abertura);
        if (!lojaAberta) lojaAberta = ValidaHorarioRestricao(config.seg_intervalo_fechamento, config.seg_fechamento);
      } else if (config.segunda == 1 && config.seg_intervalo == 0) {
        lojaAberta = ValidaHorarioRestricao(config.seg_abertura, config.seg_fechamento);
      } else lojaAberta = false;
      break;

    case 'ter':
      if (config.terca == 1 && config.ter_intervalo == 1) {
        lojaAberta = ValidaHorarioRestricao(config.ter_abertura, config.ter_intervalo_abertura);
        if (!lojaAberta) lojaAberta = ValidaHorarioRestricao(config.ter_intervalo_fechamento, config.ter_fechamento);
      } else if (config.terca == 1 && config.ter_intervalo == 0) {
        lojaAberta = ValidaHorarioRestricao(config.ter_abertura, config.ter_fechamento);
      } else lojaAberta = false;
      break;

    case 'qua':
      if (config.quarta == 1 && config.qua_intervalo == 1) {
        lojaAberta = ValidaHorarioRestricao(config.qua_abertura, config.qua_intervalo_abertura);
        if (!lojaAberta) lojaAberta = ValidaHorarioRestricao(config.qua_intervalo_fechamento, config.qua_fechamento);
      } else if (config.quarta == 1 && config.qua_intervalo == 0) {
        lojaAberta = ValidaHorarioRestricao(config.qua_abertura, config.qua_fechamento);
      } else lojaAberta = false;
      break;

    case 'qui':
      if (config.quinta == 1 && config.qui_intervalo == 1) {
        lojaAberta = ValidaHorarioRestricao(config.qui_abertura, config.qui_intervalo_abertura);
        if (!lojaAberta) lojaAberta = ValidaHorarioRestricao(config.qui_intervalo_fechamento, config.qui_fechamento);
      } else if (config.quinta == 1 && config.qui_intervalo == 0) {
        lojaAberta = ValidaHorarioRestricao(config.qui_abertura, config.qui_fechamento);
      } else lojaAberta = false;
      break;

    case 'sex':
      if (config.sexta == 1 && config.sex_intervalo == 1) {
        lojaAberta = ValidaHorarioRestricao(config.sex_abertura, config.sex_intervalo_abertura);
        if (!lojaAberta) lojaAberta = ValidaHorarioRestricao(config.sex_intervalo_fechamento, config.sex_fechamento);
      } else if (config.sexta == 1 && config.sex_intervalo == 0) {
        lojaAberta = ValidaHorarioRestricao(config.sex_abertura, config.sex_fechamento);
      } else lojaAberta = false;

      break;

    case 'sab':
    case 'sáb':
      if (config.sabado == 1 && config.sab_intervalo == 1) {
        lojaAberta = ValidaHorarioRestricao(config.sab_abertura, config.sab_intervalo_abertura);
        if (!lojaAberta) lojaAberta = ValidaHorarioRestricao(config.sab_intervalo_fechamento, config.sab_fechamento);
      } else if (config.sabado == 1 && config.sab_intervalo == 0) {
        lojaAberta = ValidaHorarioRestricao(config.sab_abertura, config.sab_fechamento);
      } else lojaAberta = false;
      break;

    default:
      break;
  }

  return lojaAberta;
}

export function isObjectEmpty(value) {
  return Object.prototype.toString.call(value) === '[object Object]' && JSON.stringify(value) === '{}';
}

export function ArredondaValores(number, decimalPlaces) {
  //return {Math.round(number * 1000) / 1000 };
  return Number(Math.round(number + 'e' + decimalPlaces) + 'e-' + decimalPlaces);
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}

export function gerarSenha(tamanho = 16) {
  const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let senha = '';

  for (let i = 0; i < tamanho; i++) {
    senha += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
  }

  return senha;
}

export const FormataValor = (valor) => {
  const valorFormatado = valor.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });

  return valorFormatado;
};

export const FormataValorNew = (amount, decimalCount = 2, decimal = ',', thousands = '.') => {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    let i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
      (decimalCount
        ? decimal + // eslint-disable-next-line prettier/prettier
        Math.abs(amount - i) // eslint-disable-next-line prettier/prettier
          .toFixed(decimalCount) // eslint-disable-next-line prettier/prettier
          .slice(2) // eslint-disable-next-line prettier/prettier
        : '')
    );
  } catch (e) {
    return '0,00';
  }
};

export const Capitalize = (string) => {
  if (!string) return string;
  const capitalized = string
    .trim()
    .toLowerCase()
    .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));

  return capitalized;
};

export const SetTitleFavicon = (logo, fantasia) => {
  {
    fantasia &&
      (document.title = fantasia
        .trim()
        .toLowerCase()
        .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase())));
  }

  function getFaviconEl() {
    return document.getElementById('favicon');
  }
  const favicon = getFaviconEl(); // Accessing favicon element

  if (logo) favicon.href = process.env.REACT_APP_MEDIA_URL + logo;
};

export function useScriptFromUrl(url, assincrono = true) {
  const script = document.createElement('script');
  script.src = url;
  script.async = assincrono;

  document.body.appendChild(script);
}

export function IniciaGoogleMaps() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyDZiwAcckLZvMeXzy180FBMrbtFt4xhTy0',
    language: 'pt',
    region: 'BR',
    libraries: googleMapsLibraries,
  });

  return isLoaded;
}

//Verifica se o formato do Email esta correto
export function ValidarEmail(mail) {
  var er = new RegExp(/^[A-Za-z0-9_\-\\.]+@[A-Za-z0-9_\-\\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);

  if (typeof mail == 'string') {
    if (er.test(mail)) {
      return true;
    }
  } else if (typeof mail == 'object') {
    if (er.test(mail.value)) {
      return true;
    }
  } else {
    return false;
  }
  return false;
}

//Valida o CPF
export function ValidarCPF(cpf) {
  var fatores = [10, 9, 8, 7, 6, 5, 4, 3, 2];
  var totalMultiplicacao = 0;
  var resto = 0;
  var primeiroDigito = 0;
  var segundoDigito = 0;
  var retorno = false;

  if (cpf.length != 11) {
    return retorno;
  }

  //-----------Obtendo o primeiro digito------------
  for (var i = 0; i < 9; i++) {
    totalMultiplicacao += fatores[i] * parseInt(cpf[i]);
  }
  resto = (totalMultiplicacao * 10) % 11;
  if (resto == parseInt(cpf[9])) {
    primeiroDigito = resto;
  }

  //-----------Obtendo o segundo digito------------

  //Adiconando o fator 11 na posição 0 da lista
  fatores.unshift('11');

  //Limpando variável do resultado da multiplicação
  totalMultiplicacao = 0;
  for (let i = 0; i < 9; i++) {
    totalMultiplicacao += fatores[i] * parseInt(cpf[i]);
  }

  totalMultiplicacao += fatores[9] * primeiroDigito;

  resto = (totalMultiplicacao * 10) % 11;

  if (resto == parseInt(cpf[10])) {
    segundoDigito = resto;
  }

  //Validando se o digito verificador bate com o do cpf
  if (primeiroDigito == parseInt(cpf[9]) && segundoDigito == parseInt(cpf[10])) {
    retorno = true;
  }

  return retorno;
}

export const cpfMask = (value) => {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

/**
 * Cria elemento csdp para o antifraude da Clearsale
 */
export function CreateElementFingerPrint(app, session) {
  const cs = window.csdp;
  cs('app', app);
  cs('sessionid', session);
}

// ******************** MÉTODOS ÚTEIS ******************** //

// ******************** MÉTODOS LANÇAMENTO ******************** //
export function GeraID(idLoja) {
  let id = encryptStorage.getItem(idLoja + 'id');
  if (id == null) {
    id = 1;
  } else {
    id = id + 1;
  }
  encryptStorage.setItem(idLoja + 'id', id);
  return id;
}

export function GetSacolaItensCount(idloja) {
  const sacola = GetAllItensSacola(idloja);
  if (!sacola) return { itensCount: 0, vTotal: 0 };

  let itensCount = 0;
  let vTotal = 0;

  sacola
    .filter(
      ({ montagem_id, adicionais_id, obrigatorio_id }) => montagem_id == 0 && adicionais_id == 0 && obrigatorio_id == 0,
    )
    .map((p) => {
      if (p.tipo_produto === 'PIZZA' && p.tipoPizza === 'FRACAO') itensCount++;
      else itensCount += p.quantidade;
      if (p.principal_id > 0) {
        const temp = GetItensMontagem(sacola, p); //pizza_cobranca
        vTotal += temp.vTotal;
      } else {
        vTotal += p.total;
      }
    });

  return {
    itensCount: itensCount,
    vTotal: ArredondaValores(vTotal, 2),
  };
}

export function GetAllItensSacola(idloja) {
  return encryptStorage.getItem(idloja + 'sacola');
}

export const GetItensMontagem = (basket, item) => {
  let description = '';
  let itensMontagem = '';
  //let vTotal = item.total;
  let vTotal = item.subtotal;
  let vAcrescimo = item.acrescimo;
  let vDesconto = item.desconto;
  let vServico = item.servico || 0;

  basket // PIZZA OU COMBO
    .filter((p) => p.montagem_id == item.principal_id)
    .map((mont) => {
      // CALCULA A PIZZA
      if (item.tipo_produto == 'PIZZA' && mont.quantidade > 0) {
        vTotal += mont.subtotal;
        vAcrescimo += mont.acrescimo;
        vDesconto += mont.desconto;
        vServico += mont.servico;
      }

      if (item.tipo_produto == 'PIZZA') {
        description = mont.quantidade_texto + ' ' + '\u00A0' + Capitalize(mont.descricao_produto);
        if (itensMontagem == '') itensMontagem = description;
        else if (itensMontagem != '') itensMontagem += ', ' + description;
      } else {
        description = mont.quantidade + 'x ' + '\u00A0' + Capitalize(mont.descricao_produto);
        if (itensMontagem == '') itensMontagem = description;
        else if (itensMontagem != '') itensMontagem += ', ' + description;
      }
    });

  basket // OBRIGATORIOS
    .filter((p) => p.obrigatorio_id == item.principal_id)
    .map((obrg) => {
      vTotal += obrg.subtotal;
      vAcrescimo += obrg.acrescimo;
      vDesconto += obrg.desconto;
      vServico += obrg.servico;
      description = obrg.quantidade + 'x ' + '\u00A0' + Capitalize(obrg.descricao_produto);
      if (itensMontagem == '') itensMontagem = description;
      else if (itensMontagem != '') itensMontagem += ', ' + description;
    });

  basket // ADICIONAIS
    .filter((p) => p.adicionais_id == item.principal_id)
    .map((adic) => {
      vTotal += adic.subtotal;
      vAcrescimo += adic.acrescimo;
      vDesconto += adic.desconto;
      vServico += adic.servico;
      description = adic.quantidade + 'x ' + '\u00A0' + Capitalize(adic.descricao_produto);
      if (itensMontagem == '') itensMontagem = description;
      else if (itensMontagem != '') itensMontagem += ', ' + description;
    });

  return {
    vTotal: vTotal,
    vDesconto: vDesconto,
    vAcrescimo: vAcrescimo,
    vServico: vServico,
    itensMontagem: itensMontagem,
  };
};

function getDifferenceInMinutes(date1, date2) {
  const diffInMs = Math.abs(date2 - date1);
  return diffInMs / (1000 * 60);
}

export function ValidDateTimeBasket(idloja, setSacola) {
  const dateTimeSacola = GetDateTimeSacola(idloja);
  const diffMins = getDifferenceInMinutes(dateTimeSacola, new Date());
  if (diffMins >= 45) ClearPedido(idloja, setSacola);
}

export async function GetListMontagemEnvio(sacola, type, principal_id) {
  let _itensMontagem = [];
  if (principal_id === 0) {
    return _itensMontagem;
  }

  let _idMontagem = 0;
  let _idObrigatorio = 0;
  let _idAdicional = 0;

  switch (type) {
    case 'montagem':
      _idMontagem = principal_id;
      break;

    case 'obrigatorio':
      _idObrigatorio = principal_id;
      break;

    case 'adicional':
      _idAdicional = principal_id;
      break;

    default:
      break;
  }

  if (sacola) {
    await Promise.all(
      sacola
        .filter(
          ({ montagem_id, obrigatorio_id, adicionais_id }) =>
            montagem_id === _idMontagem && obrigatorio_id === _idObrigatorio && adicionais_id === _idAdicional,
        )
        .map(async (item) => {
          _itensMontagem.push({
            id: item.id,
            principal_id: item.principal_id,
            montagem_id: item.montagem_id,
            obrigatorio_id: item.obrigatorio_id,
            adicionais_id: item.adicionais_id,
            codigo_produto: item.codigo_produto,
            descricao_produto: item.descricao_produto,
            quantidade: item.quantidade,
            unidade_venda: item.unidade_venda,
            valor_unitario: item.valor_unitario,

            observacao_pedido: item.observacao_pedido,

            subgrupo: item.subgrupo,
            tipo_produto: item.tipo_produto,
            tipo_pizza: item.tipo_pizza,
            pizza_qtd_max: item.pizza_qtd_max,
            pizza_qtd_pedacos_lancado: item.pizza_qtd_pedacos_lancado,
            quantidade_texto: item.quantidade_texto,
            mesa: item.mesa,
            numero_mesa: item.numero_mesa,
            posicao: item.posicao,
            numero_terminal_lancamento: item.numero_terminal_lancamento,
            setor_impressao: item.setor_impressao,
            modulo: item.modulo,
            codigo_operador: item.codigo_operador,
            nome_operador: item.nome_operador,
            subtotal: item.subtotal,
            desconto: item.desconto,
            acrescimo: item.acrescimo,
            total: item.total,
            desconto_automatico: item.desconto_automatico,
            acrescimo_automatico: item.acrescimo_automatico,
            servico: item.servico,
            total_com_servico: item.total_com_servico,
            ItensMontagem: [],
            ItensObrigatorios: [],
            ItensAdicionais: [],
          });
        }),
    );
  }
  return _itensMontagem;
}

export async function GetListPedidosEnvio(idLoja) {
  const sacola = await GetAllItensSacola(idLoja);
  let itens = [];

  if (sacola) {
    await Promise.all(
      sacola
        .filter(
          ({ montagem_id, adicionais_id, obrigatorio_id }) =>
            montagem_id === 0 && adicionais_id === 0 && obrigatorio_id === 0,
        )
        .map(async (item) => {
          itens.push({
            id: item.id,
            principal_id: item.principal_id,
            montagem_id: item.montagem_id,
            obrigatorio_id: item.obrigatorio_id,
            adicionais_id: item.adicionais_id,
            codigo_produto: item.codigo_produto,
            descricao_produto: item.descricao_produto,
            quantidade: item.quantidade,
            unidade_venda: item.unidade_venda,
            valor_unitario: item.valor_unitario,

            observacao_pedido: item.observacao_pedido,

            subgrupo: item.subgrupo,
            tipo_produto: item.tipo_produto,
            tipo_pizza: item.tipo_pizza,
            pizza_qtd_max: item.pizza_qtd_max,
            pizza_qtd_pedacos_lancado: item.pizza_qtd_pedacos_lancado,
            quantidade_texto: item.quantidade_texto,
            mesa: item.mesa,
            numero_mesa: item.numero_mesa,
            posicao: item.posicao,
            numero_terminal_lancamento: item.numero_terminal_lancamento,
            setor_impressao: item.setor_impressao,
            modulo: item.modulo,
            codigo_operador: item.codigo_operador,
            nome_operador: item.nome_operador,
            subtotal: item.subtotal,
            desconto: item.desconto,
            acrescimo: item.acrescimo,
            total: item.total,
            desconto_automatico: item.desconto_automatico,
            acrescimo_automatico: item.acrescimo_automatico,
            servico: item.servico,
            total_com_servico: item.total_com_servico,
            ItensMontagem: await GetListMontagemEnvio(sacola, 'montagem', item.principal_id),
            ItensObrigatorios: await GetListMontagemEnvio(sacola, 'obrigatorio', item.principal_id),
            ItensAdicionais: await GetListMontagemEnvio(sacola, 'adicional', item.principal_id),
          });
        }),
    );
  }

  return itens;
}

export function GetSacola(param, enderecos) {
  const basket = GetAllItensSacola(param.IdLoja);
  let Subtotal = 0;
  let Total = 0;
  let Taxa = 0;
  let itens = [];

  // CALCULA OS TOTAIS
  if (basket) {
    itens = basket
      .filter(
        ({ montagem_id, adicionais_id, obrigatorio_id }) =>
          montagem_id == 0 && adicionais_id == 0 && obrigatorio_id == 0,
      )
      .map((item) => {
        if (item.principal_id > 0) {
          const montagem = GetItensMontagem(basket, item); //param.Empresa.Config.pizza_cobranca
          Subtotal += montagem.vTotal;
          return { Produto: item, ItensMontagemText: montagem.itensMontagem, VTotal: montagem.vTotal };
        } else {
          Subtotal += item.total;
          return { Produto: item, ItensMontagemText: '', VTotal: item.total };
        }
      });

    // se for auto atendimento balcao, altera os valores para calcular o servico corretamente
    if (param.TipoApp === 'BALCAO') {
      param.Empresa.Config.taxa_tipo = '%';
      param.Empresa.Config.taxa_valor = param.Empresa.Config.habilitar_servico_balcao
        ? param.Empresa.Config.percentual_servico_balcao
        : 0;
    }

    switch (param.Empresa.Config.taxa_tipo) {
      case '%':
        Taxa = ArredondaValores((Subtotal * param.Empresa.Config.taxa_valor) / 100, 2);
        break;

      case 'R$':
        Taxa = param.Empresa.Config.taxa_valor;
        break;

      case 'Km':
      case 'Regiao':
      case 'Região':
        if (enderecos) {
          if (enderecos.length > 0) {
            if (enderecos[0].taxa) Taxa = enderecos[0].taxa;
          } else if (enderecos.taxa) Taxa = enderecos.taxa;
        }

        break;

      default:
        break;
    }

    Total = Subtotal + Taxa;
  } // CALCULA OS TOTAIS

  return {
    itens: itens,
    total: ArredondaValores(Total, 2),
    subtotal: ArredondaValores(Subtotal, 2),
    taxa: Taxa,
  };
}

export function HandleAddItem(
  dadosApp,
  produto = null,
  pedido = null,
  obs = '',
  principal_id = 0,
  montagem_id = 0,
  obrigatorio_id = 0,
  adicionais_id = 0,
) {
  if (produto == null || pedido == null) return false;
  let modulo = 'DELIVERY';
  if (dadosApp.Empresa.tipo_app == 'CLUBE') modulo = 'DELIVERY';
  if (dadosApp.Empresa.tipo_app == 'DELIVERY') modulo = 'DELIVERY';
  if (dadosApp.Empresa.tipo_app == 'RESTAURANTE' || dadosApp.Empresa.tipo_app == 'MESA') modulo = 'MESA';
  if (dadosApp.portaria) modulo = 'CARTAO';
  const obj = {
    id: produto.id,
    codigo_operador: modulo === 'MESA' ? 9997 : 0,
    nome_operador: modulo === 'MESA' ? 'GW AUTO ATENDIMENTO' : '',
    idloja: dadosApp.Empresa.codigo_sistema, //produto.idloja,
    fantasia: dadosApp.Empresa.fantasia,
    razao: dadosApp.Empresa.razao,
    numero_mesa: pedido.numero_mesa == undefined ? 0 : pedido.numero_mesa,
    codigo_produto: produto.codigo,
    descricao_produto: produto.descricao,
    observacao_pedido: obs,
    grupo: produto.grupo,
    subgrupo: produto.subgrupo,
    unidade_venda: produto.und_venda || produto.unidade_venda || 'UN',
    local_impressao: produto.impressao,
    valor_unitario: produto.preco_app,
    preco_pizza: produto.preco_pizza == undefined ? 0 : produto.preco_pizza,
    quantidade: produto.quantidade,
    quantidade_fracionada:
      produto.quantidade_fracionada == undefined ? produto.quantidade : produto.quantidade_fracionada,
    subtotal: pedido.subtotal,
    desconto: pedido.desconto == undefined ? 0 : pedido.desconto,
    acrescimo: pedido.acrescimo == undefined ? 0 : pedido.acrescimo,
    total: pedido.total,
    desconto_automatico: pedido.desconto_automatico == undefined ? 0 : pedido.desconto_automatico,
    acrescimo_automatico: pedido.acrescimo_automatico == undefined ? 0 : pedido.acrescimo_automatico,
    servico: pedido.servico == undefined ? 0 : pedido.servico,
    total_com_servico: pedido.total_com_servico,
    obrigatorio_id: obrigatorio_id,
    adicionais_id: adicionais_id,
    quantidade_texto: produto.quantidade_texto,
    montagem_id: montagem_id,
    tipo_produto: produto.tipo_produto,
    tipoPizza: produto.tipoPizza == undefined ? 'INTEIRA' : produto.tipoPizza,
    principal_id: principal_id,
    titulo_especial: '',
    mesa: pedido.mesa == undefined ? 0 : pedido.mesa,
    posicao: pedido.posicao == undefined ? 0 : pedido.posicao,
    setor_lancamento: 'GARCOM WEB',
    numero_terminal_lancamento: 99,
    modulo: modulo === 'MESA' ? 'Mesa' : modulo,
    local_pedido: pedido.local_pedido == undefined ? '' : pedido.local_pedido, // não esta sendo utilizado, o correto é setor_impressao
    setor_impressao: pedido.setor_impressao == undefined ? '' : pedido.setor_impressao,
    tipo_app: dadosApp.Empresa.tipo_app,
    data_hora: new Date(),
    tamanho: produto.tamanho, // adicionado por causa dos produtos que tem tamanho
  };
  AddItem(obj);
  return true;
}

export function AddItem(obj) {
  let sacola = GetAllItensSacola(obj.idloja);
  if (!sacola) {
    sacola = [];
  }
  // find the index of the item if already in basket
  const Index = sacola.findIndex((p) => p.id === obj.id);
  if (Index !== -1) {
    //sacola[Index].id = id;
    sacola[Index].idloja = obj.idloja;
    sacola[Index].fantasia = obj.fantasia;
    sacola[Index].razao = obj.razao;
    sacola[Index].numero_mesa = obj.numero_mesa;
    sacola[Index].codigo_produto = obj.codigo_produto;
    sacola[Index].descricao_produto = obj.descricao_produto;
    sacola[Index].observacao_pedido = obj.observacao_pedido;
    sacola[Index].grupo = obj.grupo;
    sacola[Index].subgrupo = obj.subgrupo;
    sacola[Index].unidade_venda = obj.unidade_venda;
    sacola[Index].local_impressao = obj.local_impressao;
    sacola[Index].valor_unitario = obj.valor_unitario;
    sacola[Index].preco_pizza = obj.preco_pizza;
    sacola[Index].quantidade = obj.quantidade;
    sacola[Index].quantidade_fracionada = obj.quantidade_fracionada;
    sacola[Index].subtotal = obj.subtotal;
    sacola[Index].desconto = obj.desconto;
    sacola[Index].acrescimo = obj.acrescimo;
    sacola[Index].total = obj.total;
    sacola[Index].desconto_automatico = obj.desconto_automatico;
    sacola[Index].acrescimo_automatico = obj.acrescimo_automatico;
    sacola[Index].servico = obj.servico;
    sacola[Index].total_com_servico = obj.total_com_servico;
    sacola[Index].obrigatorio_id = obj.obrigatorio_id;
    sacola[Index].adicionais_id = obj.adicionais_id;
    sacola[Index].quantidade_texto = obj.quantidade_texto;
    sacola[Index].montagem_id = obj.montagem_id;
    sacola[Index].tipo_produto = obj.tipo_produto;
    sacola[Index].tipoPizza = obj.tipoPizza;
    sacola[Index].principal_id = obj.principal_id;
    sacola[Index].titulo_especial = obj.titulo_especial;
    sacola[Index].mesa = obj.mesa;
    sacola[Index].posicao = obj.posicao;
    sacola[Index].setor_lancamento = obj.setor_lancamento;
    sacola[Index].modulo = obj.modulo;
    sacola[Index].local_pedido = obj.local_pedido;
    sacola[Index].tipo_app = obj.tipo_app;
  } else {
    sacola.push(obj); // Push not existing data to localstorage
  }
  encryptStorage.setItem(obj.idloja + 'sacola', JSON.stringify(sacola));
  SetDateTimeSacola(obj.idloja, new Date());
}

function SetDateTimeSacola(idloja, datetime) {
  encryptStorage.setItem(idloja + 'date', datetime);
}

function GetDateTimeSacola(idloja) {
  let datetime = encryptStorage.getItem(idloja + 'date');
  if (!datetime) {
    datetime = new Date();
  }
  return new Date(datetime);
}

export function ClearPedido(idloja, setSacola) {
  encryptStorage.removeItem(idloja + 'sacola');
  encryptStorage.removeItem(idloja + 'id');
  encryptStorage.removeItem(idloja + 'date');
  setSacola({ TotalItens: 0, ValorTotal: 0 });
}

export function RemoveItem(idloja, idProduto) {
  let sacola = GetAllItensSacola(idloja);
  if (!sacola) {
    return;
  }

  let temp = sacola;
  let i = 0;

  while (i < sacola.length) {
    if (temp[i].id === idProduto) {
      temp.splice(i, 1);
    } else if (temp[i].montagem_id === idProduto) {
      temp.splice(i, 1);
    } else if (temp[i].obrigatorio_id === idProduto) {
      temp.splice(i, 1);
    } else if (temp[i].adicionais_id === idProduto) {
      temp.splice(i, 1);
    } else {
      ++i;
    }
  }

  if (!temp) {
    // EXCLUI TODO O CARRINHO
    encryptStorage.removeItem(idloja + 'sacola');
  } else {
    // GRAVA O TEMP POIS ELE CONTEM OS ITENS RESTANTES QUE NÃO FORAM EXCLUÍDOS
    encryptStorage.setItem(idloja + 'sacola', JSON.stringify(temp));
  }
}

export function RemoveItensEdicao(idloja, idsExcluir) {
  let sacola = GetAllItensSacola(idloja),
    temp = sacola,
    i = 0;

  if (!sacola) {
    return;
  }

  for (i = 0; i < idsExcluir.length; i++) {
    let idProduto = idsExcluir[i];

    let itemIndexInBasket = temp.findIndex((basketEntry) => basketEntry.id === idProduto);
    if (itemIndexInBasket !== -1) {
      temp.splice(itemIndexInBasket, 1);
    }

    itemIndexInBasket = temp.findIndex((basketEntry) => basketEntry.montagem_id === idProduto);
    if (itemIndexInBasket !== -1) {
      temp.splice(itemIndexInBasket, 1);
    }

    itemIndexInBasket = temp.findIndex((basketEntry) => basketEntry.obrigatorio_id === idProduto);
    if (itemIndexInBasket !== -1) {
      temp.splice(itemIndexInBasket, 1);
    }

    itemIndexInBasket = temp.findIndex((basketEntry) => basketEntry.adicionais_id === idProduto);
    if (itemIndexInBasket !== -1) {
      temp.splice(itemIndexInBasket, 1);
    }
  }

  if (!temp) {
    // EXCLUI TODO O CARRINHO
    encryptStorage.removeItem(idloja + 'sacola');
  } else {
    // GRAVA O TEMP POIS ELE CONTEM OS ITENS RESTANTES QUE NÃO FORAM EXCLUÍDOS
    encryptStorage.setItem(idloja + 'sacola', JSON.stringify(temp));
  }
}
// ******************** MÉTODOS LANÇAMENTO ******************** //

export function SetDadosLoja(dadosApp) {
  encryptStorage.setItem('@DADOS_LOJA', JSON.stringify(dadosApp));
}

export function GetDadosLoja() {
  return encryptStorage.getItem('@DADOS_LOJA');
}

// ******************** MÉTODOS USUÁRIOS ******************** //

export function SaveUser(idloja, usuario, setUser) {
  encryptStorage.setItem(idloja + 'user', JSON.stringify(usuario));
  setUser(usuario); // grava no context
}

export function RemoveUser(idloja, setUser, setEnderecos) {
  encryptStorage.removeItem(idloja + 'user');
  setUser((prevState) => {
    return {
      ...prevState,
      id: 0,
      idloja: 0,
      ativo: undefined,
      nome: '',
      sobrenome: '',
      nome_completo: '',
      email: '',
      senha: '',
      telefone_ddd: '',
      telefone: '',
      empresa_fantasia: '',
      empresa_razao: '',
      data_aniversario: '2011-01-01',
      cpf: '',
      sexo: 'Masculino',
    };
  });
  // setUser({
  //   id: 0,
  //   idloja: 0,
  //   nome: '',
  //   sobrenome: '',
  //   nome_completo: '',
  //   email: '',
  //   senha: '',
  //   telefone_ddd: '',
  //   telefone: '',
  //   empresa_fantasia: '',
  //   empresa_razao: '',
  //   data_aniversario: '2011-01-01',
  //   cpf: '',
  //   sexo: 'Masculino',
  // });
  // setEnderecos((prevState) => {
  //   return {
  //     ...prevState,
  //     id: 0,
  //     idloja: 0,
  //     cep: '',
  //     codigo_cliente: 0,
  //     endereco: '',
  //     endereco_bairro: '',
  //     endereco_cidade: '',
  //     endereco_estado: '',
  //     endereco_numero: '',
  //     latitude: 0,
  //     longitude: 0,
  //     titulo: '',
  //     ativo: 0,
  //   };
  // });
  setEnderecos([]);
}

export function GetUsuario(idloja) {
  return encryptStorage.getItem(idloja + 'user');
}

// ******************** QLUB RETURN CONTEXT ******************** //

export const QLUB_RETURN_CONTEXT_KEY = '@QLUB_RETURN_CONTEXT';
export const QLUB_RETURN_TTL_MS = 2 * 60 * 60 * 1000; // 2h

export function saveQlubReturnContext({ returnUrl, idLoja, orderId }) {
  encryptStorage.setItem(
    QLUB_RETURN_CONTEXT_KEY,
    JSON.stringify({ returnUrl, idLoja, orderId: String(orderId || ''), ts: Date.now() }),
  );
}

export function getQlubReturnContext() {
  try {
    const raw = encryptStorage.getItem(QLUB_RETURN_CONTEXT_KEY);
    if (!raw) return null;
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch (e) {
    return null;
  }
}

export function clearQlubReturnContext() {
  encryptStorage.removeItem(QLUB_RETURN_CONTEXT_KEY);
}

export function isQlubReturnContextValid(ctx, now = Date.now()) {
  if (!ctx || !ctx.returnUrl || !ctx.idLoja) return false;
  if (ctx.ts && now - ctx.ts > QLUB_RETURN_TTL_MS) return false;
  return true;
}

export function appendQlubReturnFlag(returnUrl, orderId) {
  const sep = returnUrl.includes('?') ? '&' : '?';
  const orderPart = orderId ? `&qlub_orderId=${encodeURIComponent(orderId)}` : '';
  return `${returnUrl}${sep}qlub_return=1${orderPart}`;
}

export function buildQlubFallbackUrl(idLoja) {
  return `/loja/${idLoja}?modulo=BALCAO&qlub_return=1`;
}

// export function PagSeguroSetSessionId(dadosApp, setDadosApp) {
//   // aguarda 3 segundos para garantir que a biblioteca já foi importada
//   setTimeout(() => {
//     window.PagSeguroDirectPayment.setSessionId(dadosApp.GuidSessao);
//     window.PagSeguroDirectPayment.onSenderHashReady(function (response) {
//       if (response) {
//         if (response.status == 'error') {
//           return false;
//         }
//         setDadosApp((prevState) => {
//           return {
//             ...prevState,
//             sH: response.senderHash,
//           };
//         });
//       }
//     });
//   }, 3000);
// }

// ******************** MÉTODOS USUÁRIOS ******************** //

// função que permite adicionar qualquer biblioteca externa ao React
export function AddLibrary(urlOfTheLibrary) {
  const script = document.createElement('script');
  script.src = urlOfTheLibrary;
  script.async = true;
  document.body.appendChild(script);
}
